import { observable, makeObservable } from "mobx"

class LoadStore {
  firstLoaded = false
  threeJsLoaded = false

  constructor() {
    makeObservable(this, {
      firstLoaded: observable,
      threeJsLoaded: observable,
    })
  }
}

export default new LoadStore()
